import { render } from "./ToothSelector.vue?vue&type=template&id=6041ae1e&scoped=true"
import script from "./ToothSelector.vue?vue&type=script&lang=js"
export * from "./ToothSelector.vue?vue&type=script&lang=js"

import "./ToothSelector.vue?vue&type=style&index=0&id=6041ae1e&scoped=true&lang=css"

import exportComponent from "/src/clientapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6041ae1e"]])

export default __exports__